'use strict';

var _ = require('lodash');
var BaseStaticView = require('actions/shared/AbstractStaticView');
var tpl = require('actions/traceroute/static.html');
var twig = require('twig').twig;

/**
 * Renders a text-only version of the "Traceroute" component.
 */
module.exports = BaseStaticView.extend({
  /**
   * @name actions/traceroute/StaticView#model
   * @type {actions/traceroute/Traceroute}
   */

  template: twig({data: tpl}),

  templateContext: function() {
    var baseHelpers = BaseStaticView.prototype.templateContext.apply(this);

    return _.extend({}, baseHelpers, {
      resultText: this._resultText,
    });
  },

  /**
   * Format model's result value for display
   * Splits into array on newlines
   *
   * @returns {Array}
   * @private
   */
  _resultText: function() {
    return this.result.split('\n');
  },
});
